import api from "./api";

const buildParams = (filters) => {
  const p = new URLSearchParams();
  if (!filters) return p;
  const {
    page,
    page_size,
    date_from,
    date_to,
    status,
    project_id,
    investor_id,
    txn_type,
    movement_type,
    fee_type,
    archive,
  } = filters;
  if (page != null) p.set("page", String(page));
  if (page_size != null) p.set("page_size", String(page_size));
  if (date_from) p.set("date_from", date_from);
  if (date_to) p.set("date_to", date_to);
  if (status) p.set("status", status);
  if (project_id) p.set("project_id", project_id);
  if (investor_id) p.set("investor_id", investor_id);
  if (txn_type) p.set("txn_type", txn_type);
  if (movement_type) p.set("movement_type", movement_type);
  if (fee_type) p.set("fee_type", fee_type);
  if (archive) p.set("archive", "true");
  return p;
};

export const adminHistoryDeposits = (filters) =>
  api.get(`/admin/history/deposits/?${buildParams(filters)}`);
export const adminHistoryWithdrawals = (filters) =>
  api.get(`/admin/history/withdrawals/?${buildParams(filters)}`);
export const adminHistoryTransactions = (filters) =>
  api.get(`/admin/history/transactions/?${buildParams(filters)}`);
export const adminHistoryRedemptions = (filters) =>
  api.get(`/admin/history/redemptions/?${buildParams(filters)}`);
export const adminHistoryTransfers = (filters) =>
  api.get(`/admin/history/transfers/?${buildParams(filters)}`);
export const adminHistoryPlatformFees = (filters) =>
  api.get(`/admin/history/platform-fees/?${buildParams(filters)}`);

export const investorHistoryDeposits = (filters) =>
  api.get(`/investor/history/deposits/?${buildParams(filters)}`);
export const investorHistoryWithdrawals = (filters) =>
  api.get(`/investor/history/withdrawals/?${buildParams(filters)}`);
export const investorHistoryTransactions = (filters) =>
  api.get(`/investor/history/transactions/?${buildParams(filters)}`);
export const investorHistoryRedemptions = (filters) =>
  api.get(`/investor/history/redemptions/?${buildParams(filters)}`);
export const investorHistoryTransfers = (filters) =>
  api.get(`/investor/history/transfers/?${buildParams(filters)}`);

export const requestAdminArchiveReport = (payload) =>
  api.post("/admin/history/archive-request/", payload);

const pdfPath = (isAdmin, section) =>
  isAdmin ? `/admin/history/${section}/pdf/` : `/investor/history/${section}/pdf/`;

export function downloadHistoryPdf(isAdmin, section, filters) {
  const p = buildParams({ ...filters, page: 1, page_size: 5000 });
  const path = `${pdfPath(isAdmin, section)}?${p.toString()}`;
  return api.get(path, { responseType: "blob" });
}
